export default class Review {
  readonly id: number
  readonly body: string
  readonly rank: number

  constructor(data: { [key: string]: any }) {
    this.id = data.id
    this.body = data.body
    this.rank = data.rank
  }
}
